import { BASE_URL } from '@constants';

export const setSEOLang = (language: string) => {
    document.documentElement.setAttribute('lang', language);
    document.querySelector('meta[http-equiv="Content-Language"]')?.setAttribute('content', language);
    document.querySelector('meta[property="og:locale"]')?.setAttribute('content', language);
};

export const setSEOSiteName = (marketplaceName: string) => {
    document.querySelector('meta[property="og:site_name"]')?.setAttribute('content', marketplaceName);
    document.querySelector('meta[name="twitter:site_name"]')?.setAttribute('content', marketplaceName);
    document.querySelector('meta[property="article:author"]')?.setAttribute('content', BASE_URL);
};

export const setSEOTitle = (title: string) => {
    document.title = title || '';
    document.querySelector('meta[property="article:section"]')?.setAttribute('content', title);
    document.querySelector('meta[name="twitter:title"]')?.setAttribute('content', title);
};

export const setSEODescription = (description: string) => {
    document.querySelector('meta[name="description"]')?.setAttribute('content', description);
    document.querySelector('meta[property="og:description"]')?.setAttribute('content', description);
    document.querySelector('meta[name="twitter:description"]')?.setAttribute('content', description);
};

export const setSEOAuthor = (author: string) => {
    document.querySelector('meta[name="author"]')?.setAttribute('content', author);
};

export const setSEOArticleTags = (tags: string[]) => {
    // remove current article tags
    const currentTags = document.querySelectorAll('meta[property="article:tag"]');
    currentTags.forEach((tag) => tag.remove());
    // add new article tags
    tags.forEach((tag) => {
        const newArticleTag = document.createElement('meta');
        newArticleTag.setAttribute('property', 'article:tag');
        newArticleTag.setAttribute('content', tag);
        document.head.appendChild(newArticleTag);
    });
};

export const setSEOUrl = (link: string) => {
    const fullLink = `${BASE_URL}/${link}`;
    document.querySelector('link[rel="canonical"]')?.setAttribute('href', fullLink);
    document.querySelector('meta[property="og:url"]')?.setAttribute('content', fullLink);
    document.querySelector('meta[name="twitter:url"]')?.setAttribute('content', fullLink);
    document.querySelector('meta[property="article:publisher"]')?.setAttribute('content', fullLink);
};

export interface SEOImage {
    src: string;
    alt: string;
    type?: string;
    width?: number;
    height?: number;
}

export const setSEOImage: (image: SEOImage) => void = (image) => {
    document.querySelector('meta[property="og:image"]')?.setAttribute('content', image.src);
    document.querySelector('meta[property="og:image:secure_url"]')?.setAttribute('content', image.src);
    document.querySelector('meta[property="og:image:alt"]')?.setAttribute('content', image.alt);
    document.querySelector('meta[property="og:image:type"]')?.setAttribute('content', image.type || '');
    document.querySelector('meta[property="og:image:width"]')?.setAttribute('content', `${image.width || 0}`);
    document.querySelector('meta[property="og:image:height"]')?.setAttribute('content', `${image.height || 0}`);
    document.querySelector('meta[name="twitter:image"]')?.setAttribute('content', image.src);
    document.querySelector('meta[name="twitter:image:alt"]')?.setAttribute('content', image.alt);
};

export const setSEORobots = (index: boolean) => {
    document.querySelector('meta[name="robots"]')?.setAttribute('content', index ? 'index,follow' : 'noindex,nofollow');
};

export const setSEOThemeColor = (color: string) => {
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', color || '#000000');
};

export const updateSEOUpdatedTime = () => {
    const currentTime = new Date();
    document.querySelector('meta[property="og:updated_time"]')?.setAttribute('content', currentTime.toISOString());
};
